import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import App from './App'
import { ThemeProvider } from './providers/ThemeProvider'
import { IS_NATIVE_SHELL } from './services/config'
import { installNativeShellMediaShim } from './services/nativeShellMedia'
import { useBrandStore } from './stores/brandStore'
import './css/styles.css'

// Absolutize server-relative media paths ('/uploads/...') before anything
// renders — module components (@os/spaces member list, @os/people, …) emit
// them raw, which only resolves when the page itself is served by the
// backend. No-op in the browser. See services/nativeShellMedia.ts.
installNativeShellMediaShim()

// White label: resolve the tenant brand (title, favicon, accent, marks) BEFORE
// the authenticated bootstrap — /api/brand is public precisely because the
// login page needs it and the visitor has no JWT yet. Fire-and-forget: the
// store's initial state is the stock brand, so nothing here gates first paint,
// and a failed fetch simply leaves the stock brand in place.
void useBrandStore.getState().fetchBrand()

// HashRouter under file:// (Electron packaged) and Capacitor (local WebView
// scheme) — BrowserRouter chokes on the non-http origin and React Router logs
// "No routes matched". Web stays on BrowserRouter.
const Router = IS_NATIVE_SHELL ? HashRouter : BrowserRouter

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </React.StrictMode>
)
